import { Box, Hidden, Tab, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";
import * as PropTypes from "prop-types";
import React from "react";
import history from '../history';
function FooterColumn(props) {

  const handleLinkClick = (event, el) =>{
    if(el.same){
      let url = el.url[0] === "/" ? el.url : "/"+el.url;
      event.preventDefault();
      history.push(url);
      return;
    }
    window?.open(el.url, '_blank');
  }

  return <>
      <nav aria-labelledby={`footer-title-${props.title}`}>
      <h3 id={`footer-title-${props.title}`} className={props.classes.footer_service_title}>{props.title}</h3>
      <ul className={props.classes.footer_services} aria-labelledby={`footer-title-${props.title}`} aria-label={`Lista de ${props.title}`}>
        {props.items.map((el, index) => <li key={index}><a tabIndex={0} className="link-action"  href={'#'} onClick={(e)=> handleLinkClick(e, el)}>{el.name}</a></li>)}
      </ul>
    </nav>
  </>;
}
FooterColumn.propTypes = { classes: PropTypes.any };

const styles = theme => ({
  footer: {
    background: theme.painel.Footer.footer.background,
    color: '#ffffff',
    '&:focus': {
      boxShadow: '0 0 0 2px #c2850c',
      border: '1px solid #c2850c',
      outline: 'none'
    },
    
  },
  footer_services: {
    fontSize: "0.833em",
    listStyle: 'none',
    paddingLeft: '0',
    '& li': {
      padding: '7px 0',
      lineHeight: '15px',
      '& a': {
        textDecoration: 'none',
        color: '#ffffff',
      },
      '&:last-child': {
        paddingBottom: '0',
      },
    }
  },
  footer_service_title: {
    fontSize: "1em;",
    textTransform: 'uppercase',
    fontWeight: 'bold',
    color: '#ffffff',
    padding: "0",
    margin: "0",
  },
})

class Footer extends React.Component {
  render() {
    const { classes } = this.props;

    return (
      <Hidden xsDown>
        <footer id="footer" tabIndex={-1} className={classes.footer}>
          <Box>
            <div style={{ display: "flex", gap: "0px 24px", padding: "16px 72px 40px" }}>
              <div style={{ flex: "1" }}>
                <FooterColumn classes={classes} title={'Serviços'}
                  items={[
                    { name: 'Emitir Guia de Pagamento (GPS)', url: 'https://sal.rfb.gov.br/PortalSalInternet/faces/pages/calcContribuicoesCI/filiadosApos/selecionarOpcoesCalculoApos.xhtml' },
                    { name: 'Comunicação de Acidente de Trabalho (CAT)', url: 'https://www.gov.br/pt-br/servicos/registrar-comunicacao-de-acidente-de-trabalho-cat/' },
                    { name: 'Calendário de Pagamento', url: '/aberto/calendario-pagamento', same: true },
                    { name: 'Encontre uma Agência', url: '/aberto/localizador-aps', same: true }]} />
              </div>
              <div style={{ flex: "1" }}>
                <FooterColumn classes={classes} title={'Inscrição'}
                  items={[
                    { name: 'Informações sobre inscrição', url: 'https://www.gov.br/pt-br/servicos/solicitar-inscricao-junto-ao-inss/' },
                    { name: 'Como preencher a GPS', url: 'https://www.gov.br/receitafederal/pt-br/assuntos/orientacao-tributaria/pagamentos-e-parcelamentos/emissao-e-pagamento-de-darf-das-gps-e-dae/gps-guia-da-previdencia-social-orientacoes-1/orientacoes-para-preenchimento-da-gps/'},
                    { name: 'Tipos de Filiação', url: 'https://www.gov.br/inss/pt-br/saiba-mais/seus-direitos-e-deveres/tipos-de-filiacao/' },
                    { name: 'Formas de Pagar', url: 'https://www.gov.br/inss/pt-br/direitos-e-deveres/inscricao-e-contribuicao/contribuicao-dos-segurados-facultativo-e-contribuinte-individual/' },
                    { name: 'Prazos de Recolhimento', url: 'https://www.gov.br/receitafederal/pt-br/assuntos/orientacao-tributaria/pagamentos-e-parcelamentos/emissao-e-pagamento-de-darf-das-gps-e-dae/gps-guia-da-previdencia-social-orientacoes-1/numero-de-vias-e-prazo-de-recolhimento/' },
                    { name: 'Donos de Casa', url: 'https://www.gov.br/inss/pt-br/saiba-mais/seus-direitos-e-deveres/categorias-de-segurados/facultativo-de-baixa-renda-dono-de-casa/facultativo-de-baixa-renda-dona-de-casa/' },
                    { name: 'Plano Simplificado', url: 'https://www.gov.br/inss/pt-br/direitos-e-deveres/inscricao-e-contribuicao/plano-simplificado/' }]} />
              </div>
              <div style={{ flex: "1" }}>
                <FooterColumn classes={classes} title={'Aplicativo'}
                  items={[
                    { name: 'Baixar na Play Store', url: 'https://play.google.com/store/apps/details?id=br.gov.dataprev.meuinss&hl=pt_BR' },
                    { name: 'Baixar na Apple Store', url: 'https://apps.apple.com/br/app/meu-inss/id1243048358' }]} />
              </div>
              <div style={{ flex: "1" }}>
                <FooterColumn classes={classes} title={'Suporte'} items={[
                  { name: 'Perguntas Frequentes', url: 'https://www.gov.br/inss/pt-br/acesso-a-informacao/perguntas-frequentes/' },
                  { name: 'Ouvidoria', url: 'https://falabr.cgu.gov.br/' }]} />
              </div>
            </div>
          </Box>
        </footer>
      </Hidden>
    );
  }
}

export default withStyles(styles)(Footer);
